<script setup lang="ts">
import TicketDetailPage from '@/components/TicketComponents/TicketDetailPage.vue'
</script>

<template>
    <TicketDetailPage />
</template>
